import { GatewayAuthContract } from '@terra/shared-contracts-gateway-auth';
import { createTerraOrpcClient } from '@terra/shared-utils';

export const gatewayAuthClient = createTerraOrpcClient({
  contract: GatewayAuthContract,
});
